'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../../styleInject.js');

var css_248z = ".EmailOptInForm-module_emailOptinFormContainer__UutVz{display:grid;grid-template-columns:repeat(12,1fr);grid-gap:.5rem;gap:.5rem}";
var styles = {"emailOptinFormContainer":"EmailOptInForm-module_emailOptinFormContainer__UutVz"};
styleInject["default"](css_248z, '80db78bd-b85e-4693-994b-b65cf15e5425');

exports["default"] = styles;
